import { useEffect } from 'react';
import useLiveSessionStore from './liveSessionStore';

// Pass null to opt out (e.g. before a session has started).
const useLiveSession = (sessionId: string | null | undefined) => {
  const attach = useLiveSessionStore(state => state.attach);

  useEffect(() => {
    if (!sessionId) return undefined;
    return attach(sessionId);
  }, [sessionId, attach]);

  const storeSessionId = useLiveSessionStore(state => state.sessionId);
  const connectionState = useLiveSessionStore(state => state.connectionState);
  const currentSlide = useLiveSessionStore(state => state.currentSlide);
  const studentCounts = useLiveSessionStore(state => state.studentCounts);
  const teacherDisconnectedAt = useLiveSessionStore(state => state.teacherDisconnectedAt);
  const teacherReconnectedAt = useLiveSessionStore(state => state.teacherReconnectedAt);
  const sessionEndedReason = useLiveSessionStore(state => state.sessionEndedReason);
  const performNavigate = useLiveSessionStore(state => state.performNavigate);
  const markPresent = useLiveSessionStore(state => state.markPresent);
  const markAbsent = useLiveSessionStore(state => state.markAbsent);

  // Return empty values when the store owns a different session_id — guards against stale
  // data leaking through during fast session transitions before teardown completes.
  const isOwnedSession = sessionId != null && storeSessionId === sessionId;

  return {
    connectionState: isOwnedSession ? connectionState : null,
    currentSlide: isOwnedSession ? currentSlide : null,
    studentCounts: isOwnedSession ? studentCounts : {
      connectedCount: 0,
      connectedIds: [],
      invitedIds: [],
    },
    teacherDisconnectedAt: isOwnedSession ? teacherDisconnectedAt : null,
    teacherReconnectedAt: isOwnedSession ? teacherReconnectedAt : null,
    sessionEndedReason: isOwnedSession ? sessionEndedReason : null,
    performNavigate,
    markPresent,
    markAbsent,
  };
};

export default useLiveSession;
